// src/Routes.tsx
import {
  createBrowserRouter,
  Navigate,
} from 'react-router-dom';
import Header from './components/header';
import HomePage from './components/homepage/homepage';
import LoginPage from './components/auth/login/login';
import ForgotPassword from './components/auth/forgotPassword/forgotpassword';
import { UserBase } from './components/usermgmt/userbase';
import { PasswordReqBase } from './components/passwordreqmgmt/passwordreqbase';
import PasswordReqListTable from './components/passwordreqmgmt/passwordreqmgmt';
import { VehicleBase } from './components/vehiclemgmt/vehicelbase';
import VehicleListTable from './components/vehiclemgmt/vehiclemgmt';
import { ModelBase } from './components/modelmgmt/modelbase';
import ModelListTable from './components/modelmgmt/modelmgmt';
import UserListTable from './components/usermgmt/usermgmt';
import { ClusterBase } from './components/cluster_flashing/clusterbase';
import Cluster from './components/cluster_flashing/clustertable';
import { ControllerBase } from './components/controller_flashing/controllerbase';
import Controller from './components/controller_flashing/controllertable';
import UserProfilePage from './components/usermgmt/userprofile';
import ProtectedRoute from './components/auth/protectedlayout';

const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/forgotpassword',
    element: <ForgotPassword />,
  },
  {
    path: '/',
    element: <Header />,
    children: [
      {
        path: 'home',
        element: (
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'usermanagement',
        element: <ProtectedRoute><UserBase /></ProtectedRoute>,
        children: [
          {
            index: true,
            element: <UserListTable />,
          },
        ],
      },
      {
        path: 'vehiclemanagement',
        element: <ProtectedRoute><VehicleBase /></ProtectedRoute>,
        children: [
          {
            index: true,
            element: <VehicleListTable />,
          },
        ],
      },
      {
        path: 'modelmanagement',
        element: <ProtectedRoute><ModelBase /></ProtectedRoute>,
        children: [
          {
            index: true,
            element: <ModelListTable />,
          },
        ],
      },
      {
        path: 'passwordreqmanagement',
        element: <ProtectedRoute><PasswordReqBase /></ProtectedRoute>,
        children: [
          {
            index: true,
            element: <PasswordReqListTable />,
          },
        ],
      },
      {
        path: 'cluster_flashing',
        element: <ProtectedRoute><ClusterBase /></ProtectedRoute>,
        children: [
          {
            index: true,
            element: <Cluster />,
          },
        ],
      },
      {
        path: 'profile',
        element: <ProtectedRoute><ClusterBase /></ProtectedRoute>,
        children: [
          {
            index: true,
            element: <UserProfilePage />
          },
        ],
      },
      {
        path: 'controller_flashing',
        element: <ProtectedRoute><ControllerBase /></ProtectedRoute>,
        children: [
          {
            index: true,
            element: <Controller />,
          },
        ],
      },
      {
        path: '/',
        element: <Navigate to="/login" />,
      },
    ],
  },
]);

export default router;